import React from "react";
import { Card, CardHeader, CardContent, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useStudentInfoHook from "../hook/StudentInfoHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";

const SSID = ({ schoolId, linkColor }) => {
  const { data, loading } = useStudentInfoHook(schoolId);

  const report_1_link = data.length > 0 ? data[0].report_1_link : "";
  const theme = useTheme();

  if (loading) {
    return <div>Loading...</div>;
  }
  const subject = "SSID";

  return (
    <Card>
      <CardHeader
        title="Student Information (SSID)"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {report_1_link && (
          <Typography component="div">
            <>
              <Link
                to={report_1_link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: linkColor }}
              >
                View Report
              </Link>
              <SchoolNotificationButton subject={subject} schoolId={schoolId} />
            </>
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default SSID;
